import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import ModalAlert from "../../common/modal-alert";
import ModalConfirm from "../../common/modal-confirm";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import DropMonthYear from "../../../components/DropMonthYear";
import * as CONSTANTS from "../../../services/constants";
import EmployeeTable from "./EmployeeTable";
import moment from "moment";
import { AuthenticatedLink } from "./AthenticatedLink";
import Toast from "../../../components/Toast";

// Set the timezone for every instance.
Moment.globalTimezone = "UTC";

class Detail extends Component {
  state = {
    load: false,
    functions: null,
    sectors: null,
    companyId: null,
    companyStatusId: null,
    socialName: null,
    cnpj: null,
    businessName: null,
    phone: null,
    CompanyType: null,
    CompanyTypeId: null,
    objectOfContract: null,
    email: null,
    address: null,
    number: null,
    complement: null,
    city: null,
    state: null,
    district: null,
    sectorIdSelected: null,
    sectorsSelected: null,
    documentsToUpload: {},
    documentsToUploadPeriodic: {},
    documentsToUploadMedicao: {},
    companyDocuments: {},
    companyDocumentsPeriodic: {},
    companyDocumentsMedicao: [],
    idAttachment: null,
    companyStatus: null,
    employees: {},
    companyContacts: {},
    year: moment().format("YYYY"),
    month: CONSTANTS.months()[CONSTANTS.currMonth()],
    status: {},
    employeesStatuses: [],
    typeAttach: "",
    detailEmployee: {},
    sectorDocumentsRelation: {},
    sectorDocumentsRelationPeriodic: {},
    showDocs: true,
    showDocsPeriodic: true,
    showDocsMedicao: true,
    isValidadeCalendar: true,
    titleDocumentValidate: null,
    idDocumentValidate: null,
    repostType: null,
    user_sector: localStorage.getItem("SectorId"),
    employee: window.employee,
    isEmail: false,
    toastRender: false,
    toastRenderError: false,
    toastView: false,
    timer: false,
    employeeStatusToUpdate: null,
    lostFiles: [],
    showLostFiles: false,
    approvers: [],
    selectedApprover: null,
    approverAction: 'assign',
    medicaoDocumentId: null,
    currentApprover: null,
    medicaoApproverInfo: null
  };

  componentDidMount() {
    this.searchCompany();
    localStorage.setItem("url-company", window.location.href);
    this.searchStatus();
    this.searchFunctions();
    this.searchSectors();
  }

  searchCompany = async () => {
    try {
      const response = await api.get(
        `/companies?cnpj=${this.props.match.params.id}`
      );

      if (response.data.rows.length) {
        // let dados = this.props.companyData;
        let dados = response.data.rows[0];

        this.setState({
          companyId: dados.id,
          companyStatus: dados.CompanyStatus.description,
          companyStatusId: dados.CompanyStatusId,
          socialName: dados.socialName,
          cnpj: dados.cnpj,
          businessName: dados.businessName,
          phone: dados.phone,
          CompanyType: dados.CompanyType.description,
          CompanyTypeId: dados.CompanyType.id,
          address: dados.address,
          number: dados.number,
          complement: dados.complement,
          city: dados.city,
          state: dados.state,
          district: dados.district,
          objectOfContract: dados.objectOfContract,
          sectorIdSelected: dados.Sectors.length > 0 ? dados.Sectors[0].id : 0,
          sectorsSelected: dados.Sectors
        });

        this.searchDocumentsToCompany(dados.CompanyType.id);
        this.searchDocumentsToCompanyPeriodc(dados.CompanyType.id);
        this.searchDocumentsToCompanyMedicao(dados.CompanyType.id);
        this.searchDocumentsCompany(dados.id);
        this.searchDocumentsCompanyMedicao(dados.id);
        this.searchDataEmployee(dados.id);
        this.searchContactsCompany(dados.id);
        this.searchSectorDocumentsRelation();
      } else {
        window.location.href = "../../solicitations";
      }
    } catch (err) {
      console.log(err);
      window.location.href = "../../solicitations";
    }
  };
  searchSectors = async () => {
    this.setState({ load: true });
    const response = await api.get(`/sectors?status=1`);
    this.setState({ sectors: response.data.rows, load: false });
  };

  searchFunctions = async () => {
    this.setState({ load: true });
    const response = await api.get(`/functions?order_by=description`);
    this.setState({ functions: response.data.rows, load: false });
  };

  searchApprovers = async () => {
    try {
      const response = await api.get(`/users/approvers`);
      this.setState({ approvers: response.data.approvers });
    } catch (err) {
      this.setState({ approvers: [] });
    }
  };

  searchContactsCompany = async CompanyId => {
    const companyContacts = await api.get(`/companies/${CompanyId}/contacts`);
    this.setState({ companyContacts: companyContacts.data.rows });
  };

  searchContactsCompanyFilter = async CompanyId => {
    const companyContacts = await api.get(`/employees?CompanyId=${CompanyId}`);
    this.setState({ companyContacts: companyContacts.data.rows, load: false });
  };
  // Documentos cadastrais
  searchDocumentsToCompany = async CompanyTypeId => {
    const companyTypeDocuments = await api.get(
      `/company-types/${CompanyTypeId}/documents?DocumentTypeId=1`
    );
    this.setState({ documentsToUpload: companyTypeDocuments.data.data });
  };
  // Documentos mensais
  searchDocumentsToCompanyPeriodc = async CompanyTypeId => {
    const companyTypeDocuments = await api.get(
      `/company-types/${CompanyTypeId}/documents?DocumentTypeId=2`
    );
    this.setState({
      documentsToUploadPeriodic: companyTypeDocuments.data.data
    });
  };

  // Documentos de medição
  searchDocumentsToCompanyMedicao = async CompanyTypeId => {
    const documentsToUpload = await api.get(
      `/company-types/${CompanyTypeId}/documents?DocumentTypeId=5`
    );
    this.setState({
      documentsToUploadMedicao: documentsToUpload.data.data
    });
  };

  searchDocumentsCompanyMedicao = async companyId => {
    const { year, month } = this.state;
    // Documentos de medição
    try {
      const result = await api.get(
        `/companies/${companyId}/attachments?DocumentTypeId=5&year=${year}&month=${month}`
      );
      this.setState({
        companyDocumentsMedicao: result.data.rows || [],
        medicaoApproverInfo: result.data.approverInfo || null
      });
    } catch (err) {
      // Clear Medição documents if API call fails
      this.setState({
        companyDocumentsMedicao: [],
        medicaoApproverInfo: null
      });
    }
  };

  searchDocumentsCompany = async companyId => {
    const { year, month } = this.state;
    // Documentos cadastrais
    await api
      .get(`/companies/${companyId}/attachments?DocumentTypeId=1`)
      .then(result => {
        this.setState({ companyDocuments: result.data.rows });
      });
    // Documentos mensais
    await api
      .get(
        `/companies/${companyId}/attachments?DocumentTypeId=2&year=${year}&month=${month}`
      )
      .then(result => {
        this.setState({
          companyDocumentsPeriodic: result.data.rows
        });
      });
  };

  searchSectorDocumentsRelation = async () => {
    const user_sector = localStorage.getItem("SectorId");
    const sectorDocumentsRelation = await api.get(
      `/sectors/${user_sector}/documents?DocumentTypeId=1`
    );
    const sectorDocumentsRelationPeriodic = await api.get(
      `/sectors/${user_sector}/documents?DocumentTypeId=2`
    );

    if (sectorDocumentsRelation.data.data.length > 0) {
      this.setState({
        sectorDocumentsRelation: sectorDocumentsRelation.data.data
      });
    }

    if (sectorDocumentsRelationPeriodic.data.data.length > 0) {
      this.setState({
        sectorDocumentsRelationPeriodic:
          sectorDocumentsRelationPeriodic.data.data
      });
    }
  };

  setStatusEmployee = async () => {

    console.log(window.idEmployee)
    console.log(window.employeeStatus)

    if (window.employeeStatus) {
      await api.patch(`/employees/${window.idEmployee}`, { EmployeeStatusId: window.employeeStatus }).then(result => {
        document.getElementById("close-modal-status-employee").click();
        window.location.reload();
      })
        .catch(err => {
          console.log(`Erro ao atualizar status do colaborador:${window.idEmployee}`);
          console.log(err);
        });
    } else {
      await api.patch(`/employees/${window.idEmployee}`, { EmployeeStatusId: 4 }).then(result => {
        document.getElementById("close-modal-alter-status-employee").click();
        window.location.reload();
      })
        .catch(err => {
          console.log(`Erro ao atualizar status do colaborador:${window.idEmployee}`);
          console.log(err);
        });
    }
  }

  setStatusEmployeeNew = async () => {

    console.log(window.idEmployee)
    console.log(window.employeeStatus)

    if (window.employeeStatus) {
      await api.patch(`/employees/${window.idEmployee}`, { EmployeeStatusId: window.employeeStatus }).then(result => {
        document.getElementById("close-modal-status-employee").click();
        window.location.reload();
      })
        .catch(err => {
          console.log(`Erro ao atualizar status do colaborador:${window.idEmployee}`);
          console.log(err);
        });
    } else {
      alert('Selecione um status válido!')
    }
  }

  showValidityDate = (validityDate, list) => {
    var validity = false;
    if (list.length) {
      var attachments = list.filter(
        i => i.DocumentId == validityDate[0].DocumentId
      );

      if (attachments.length) {
        validity = attachments[0].validityDate
          ? attachments[0].validityDate
          : false;
      }
    }

    if (
      this.verifyFileApproval(validityDate[0].DocumentId) &&
      this.verifyFile(validityDate[0].DocumentId, list)
    ) {
      if (validity) {
        return (
          <div>
            <Moment format="DD/MM/YYYY">{validity}</Moment>
            <button
              type="button"
              id={validityDate[0].DocumentId}
              onClick={e => this.validateDocument(e, list)}
              data-toggle="modal"
              data-target=".modal-validade-date"
              title="Alterar data de validade"
              className="btn btn-sm btn-outline-info btn-circle"
            >
              <i id={validityDate[0].DocumentId} className="fa fa-calendar" />
            </button>
          </div>
        );
      } else {
        try {
          let validity = validityDate[0].defaultValidity.split("-");
          switch (validity[1]) {
            case "years":
              return (
                <div>
                  <Moment add={{ years: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            case "months":
              return (
                <div>
                  <Moment add={{ months: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            case "weeks":
              return (
                <div>
                  <Moment add={{ weeks: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            case "days":
              return (
                <div>
                  <Moment add={{ days: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>{" "}
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            default:
              break;
          }
        } catch (error) {
          return (
            <div>
              Indefinida{" "}
              <button
                type="button"
                id={validityDate[0].DocumentId}
                onClick={e => this.validateDocument(e, list)}
                data-toggle="modal"
                data-target=".modal-validade-date"
                title="Alterar data de validade"
                className="btn btn-sm btn-outline-info btn-circle"
              >
                <i id={validityDate[0].DocumentId} className="fa fa-calendar" />
              </button>{" "}
            </div>
          );
        }
      }
    } else {
      if (validity) {
        return (
          <div>
            <Moment format="DD/MM/YYYY">{validity}</Moment>
          </div>
        );
      } else {
        try {
          let validity = validityDate[0].defaultValidity.split("-");
          switch (validity[1]) {
            case "years":
              return (
                <Moment add={{ years: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            case "months":
              return (
                <Moment add={{ months: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            case "weeks":
              return (
                <Moment add={{ weeks: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            case "days":
              return (
                <Moment add={{ days: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            default:
              break;
          }
        } catch (error) {
          return "Indefinida";
        }
      }
    }
  };

  searchDataEmployee = async (companyId, filterNome, filterStatus) => {
    let name = filterNome ? `&name=${filterNome}` : "";
    let EmployeeStatusId = filterStatus
      ? `&EmployeeStatusId=${filterStatus}`
      : "";

    const dataEmployee = await api.get(
      `/employees?order_by=name&CompanyId=${companyId}${name}${EmployeeStatusId}`
    );
    this.setState({ employees: dataEmployee.data.rows });
  };

  // Função que verifica se todos os documentos foram enviados.
  // Verifica se o documento é mensal ou periódico e conta quantos serão necessário enviar e quantos foram enviados.
  // Essa contagem é necessária para a alteração do status da empresa pois caso algum não tenha sido enviado o status não é alterado.
  verifyDocumentsSuccess = () => {
    const {
      companyDocuments,
      companyDocumentsPeriodic,
      typeAttach,
      documentsToUploadPeriodic,
      documentsToUpload
    } = this.state;

    console.log('zyad was here..')

    let documentsSuccess = companyDocuments.filter(
      item => ((item.AttachmentStatusId == 2 || item.AttachmentStatusId == 4) && this.verifyFile2(item.Document.id, documentsToUpload))
    );

    console.log(
      "QUANTIDADE DE DOCUMENTOS APROVADOS DO TIPO CADASTRAL: ",
      documentsSuccess.length
    );

    let documentsSuccessPeriodic = companyDocumentsPeriodic.filter(
      item => item.AttachmentStatusId == 2 || item.AttachmentStatusId == 4
    );
    console.log(
      "QUANTIDADE DE DOCUMENTOS APROVADOS DO TIPO MENSAL: ",
      documentsSuccessPeriodic.length
    );

    if (typeAttach == "normal") {
      if (documentsSuccess.length == documentsToUpload.length) {
        return true;
      } else {
        return false;
      }
    } else {
      if (documentsSuccessPeriodic.length == documentsToUploadPeriodic.length) {
        return true;
      } else {
        return false;
      }
    }
  };

  // Verifica se possui documentos reprovados
  hasReprovedFile = () => {
    const {
      companyDocuments: cd,
      companyDocumentsPeriodic: cp,
      typeAttach: ta
    } = this.state;

    return ta === "normal"
      ? cd.some(doc => doc.AttachmentStatusId == 4)
      : cp.some(doc => doc.AttachmentStatusId == 4);
  };

  verifyFile = (id, list) => {

    const { AprovacaoDocumentosEmpresa } = CONSTANTS.CompanyStatus;
    const { companyStatusId } = this.state;
    // if (list.length && companyStatusId === AprovacaoDocumentosEmpresa.id) {
    if (list.length) {
      return list.filter(item => item.DocumentId == id).length ? true : false;
    } else {
      return false;
    }
  };

  verifyFile2 = (id, list) => {

    if (list.length) {
      return list.filter(item => item.id == id).length ? true : false;
    } else {
      return false;
    }
  };

  verifyDocumentNotApplicable = (id, list) => {
    if (list.length) {
      const exist = list.filter(item => item.DocumentId == id);
      return exist.length > 0 ? exist[0].notapplicable : false;
    } else {
      return false;
    }
  };

  // Verifica se o documento cadastral pode ser aprovado pelo usuário logado
  verifyFileApproval = id => {
    const user_sector = localStorage.getItem("SectorId");
    if (user_sector == 3) return true;

    if (this.state.sectorDocumentsRelation.length) {
      let data = this.state.sectorDocumentsRelation.filter(
        item => item.id == id
      );
      return data.length ? data[0].DocumentToSectors.approve : false;
    } else {
      return false;
    }
  };
  // Verifica se o documento mensal pode ser aprovado pelo usuário logado
  verifyFileApprovalPeriodic = id => {
    const user_sector = localStorage.getItem("SectorId");
    if (user_sector == 3) return true;

    if (this.state.sectorDocumentsRelationPeriodic.length) {
      let data = this.state.sectorDocumentsRelationPeriodic.filter(
        item => item.id == id
      );
      return data.length ? data[0].DocumentToSectors.approve : false;
    } else {
      return false;
    }
  };

  verifyFileApprovalMedicao = id => {
    const userId = localStorage.getItem("userId");
    const { companyDocumentsMedicao } = this.state;
    
    // Ensure companyDocumentsMedicao is an array
    if (!Array.isArray(companyDocumentsMedicao)) {
      return false;
    }
    
    const document = companyDocumentsMedicao.find(doc => doc.DocumentId == id);
    
    // For Medição documents, only the assigned approver or sector 3 users can approve
    if (this.state.user_sector == 3) return true;
    
    // Check if current user is the assigned approver for this document
    if (document && document.ApproverUserId == userId) {
      return true;
    }
    
    return false;
  };

  verifyDocumentNote = (id, list) => {
    if (list.length) {
      let data = list.filter(item => item.DocumentId == id);
      return data.length ? data[0].note : "";
    } else {
      return "";
    }
  };



  verifyDocumentExpired = (id, list) => {
    if (list.length) {
      const exist = list.filter(item => item.DocumentId == id);
      if (exist.length > 0) {
        if (exist[0].expired) {
          return "Vencido";
        }
      }
    }
  };

  validateDocument = (e, list) => {
    this.setState({ load: false, msgError: null });
    document.getElementById("data_integracao").value = "";

    let attachments = list.filter(i => i.DocumentId == e.target.id);

    this.setState({
      titleDocumentValidate: attachments[0].Document.description,
      idAttachment: attachments[0].id,
      idAttachmentValidateStatus: attachments[0].AttachmentStatus.id,
      updateDate: false
    });
  };

  downloadFile = async (e, list) => {
    //  let data = list.filter(item => item.DocumentId === parseInt(e.target.id));
    // if (data.length) {
    //   let companyId = data[0].CompanyId;
    //   document
    //   .getElementById("btn_download")
    //   .setAttribute(
    //     "href",
    //     `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/attachments/${data[0].id}/file`
    //   );
    // document.getElementById("btn_download").click();
    //   }

    let data = list.filter(item => item.DocumentId === parseInt(e.target.id));
    if (data.length) {
      let companyId = data[0].CompanyId;

      // document
      //   .getElementById("btn_download")
      //   .setAttribute(
      //     "href",
      //     `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/attachments/${data[0].id}/file`
      //   );
      // document.getElementById("btn_download").click();

      this.setState({ toastRender: true, timer: null });
      const file = await api.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/attachments/${data[0].id}/stream`
      );
      this.setState({ toastRender: false, timer: 10 });
      if (file.data) {
        const linkSource = `data:${file.headers["content-type"]};base64,${file.data
          }`;
        const downloadLink = document.createElement("a");
        const fileName = data[0].originalName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        this.setState({ toastRenderError: true });
      }
      this.setState({ toastRenderError: false });
    }
  };

  viewFile = async (e, list) => {

    let data = list.filter(item => item.DocumentId == e.target.id);
    if (data.length) {
      let companyId = data[0].CompanyId;

      this.setState({ toastView: true, timer: null });
      const file = await api.get(
        `${process.env.REACT_APP_BASE_URL}/companies/${companyId}/attachments/${data[0].id}/stream`
      );
      this.setState({ toastView: false, timer: 10 });
      if (file.data) {
        let win = window.open();
        const newBlob = this.base64ToBlob(file.data, file.headers["content-type"]);

        win.document.write(
          `<iframe src="${URL.createObjectURL(newBlob)}" style="width:100vw; height:100vh"></iframe>`
        );
      } else {
        this.setState({ toastRenderError: true });
      }
      this.setState({ toastRenderError: false });
    }
  };

  base64ToBlob(base64, type) {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  }

  setStatusCompany = async () => {

    if (this.verifyDocumentsSuccess()) {
      const hasreproved = this.hasReprovedFile();
      console.log("Company: ", this.state.companyId);
      console.log("hasreproved: ", hasreproved);
      console.log("SectorId: ", this.state.sectorIdSelected);
      await api
        .patch(`/companies/${this.state.companyId}`, {
          CompanyStatusId: hasreproved ? 4 : 5,
          SectorId: this.state.sectorIdSelected
        })
        .then(async res => {
          console.log(
            "RESULTADO DA ATUALIZAÇÃO DO STATUS DA EMPRESA ------------------",
            res
          );
          await this.searchCompany();
          this.setState({
            msgAlert: res.data.msg,
            classText: "text-success",
            load: false,
            msgError: null
          });
          setTimeout(() => {
            this.setState({ msgAlert: null, classText: null });
          }, 2000);
        })
        .catch(err => {
          this.setState({
            msgError: "Erro na atualização do status da empresa",
            classText: "text-info"
          });
        });
    } else {
      console.log(
        "NÃO FOI ENVIADO TODOS OS DOCUMENTOS AINDA PARA ALTERAR O STATUS"
      );
    }
  };

  setStatusDocument = async () => {
    this.setState({ load: true });
    await api
      .patch(
        `/companies/${this.state.companyId}/attachments/${this.state.idAttachment}`,
        { AttachmentStatusId: 2, UserId: localStorage.getItem("userId") }
      )
      .then(async result => {
        console.log(
          "RESULTADO APÓS ATUALIZAÇÂO STATUS DO DOCUMENTO ------------------>",
          result
        );
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        await this.searchDocumentsToCompany(this.state.CompanyTypeId);
        await this.searchDocumentsCompany(this.state.companyId);
        await this.searchDocumentsCompanyMedicao(this.state.companyId);
        await this.setStatusCompany();


        setTimeout(() => {
          //Fechando todos os modais [GAMBI+++]
          this.closeAllModals();
          this.setState({ msgAlert: null, classText: null });
        }, 2000);

      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgError: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgError: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  setStatusRepostDocumentCompany = async () => {

    this.setState({ load: true });
    await api
      .delete(
        `/companies/${this.state.companyId}/deleteattach/${this.state.idAttachment}/${this.state.repostType}`
      )
      .then(async result => {
        console.log(
          "RESULTADO APÓS ATUALIZAÇÂO STATUS DO DOCUMENTO ------------------>",
          result
        );
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        await this.searchDocumentsToCompany(this.state.CompanyTypeId);
        await this.searchDocumentsCompany(this.state.companyId);
        await this.searchDocumentsCompanyMedicao(this.state.companyId);

        document.getElementById("close-modal-repost").click();
        // document.getElementById("modal-alert").click();
        setTimeout(() => {
          this.setState({ msgAlert: null, classText: null });
        }, 2000);
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgError: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgError: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  setNewContact = async () => {

    document.getElementById("email_contato").blur();

    this.setState({ loading: true });

    let nome = document.getElementById("nome_contato").value;
    let email = document.getElementById("email_contato").value;

    if (nome == undefined || nome == '') {
      alert('Verifique seus dados!\n Nome e E-mail são obrigatórios');
    } else {
      console.log(nome + " - " + email);

      api.post(`/companies/${this.state.companyId}/contacts`, {
        name: nome,
        email: email
      }).then((resp) => {
        this.setState({ msgError: '', msgAlert: resp.data.msg, classText: "text-success", loading: false, errors: {} });
        this.searchContactsCompany(this.state.companyId);

        setTimeout(() => {
          //Fechando todos os modais [GAMBI+++]
          this.closeAllModals();
          this.setState({ msgAlert: null, classText: null });
        }, 2000);
      }).catch(error => {
        console.log('Erro ao criar Contatos!')
        let errorMsg = error.response.data.errors.map(err => " - " + err.msg + ".\n");
        this.setState({ msgError: 'Não foi possível cadastrar o contato: \n ' + errorMsg });
      });
    }
  }

  isEmail = () => {
    let field = document.getElementById('email_contato').value;
    var usuario = field.substring(0, field.indexOf("@"));
    var dominio = field.substring(field.indexOf("@") + 1, field.length);
    if ((usuario.length >= 1) &&
      (dominio.length >= 3) &&
      (usuario.search("@") == -1) &&
      (dominio.search("@") == -1) &&
      (usuario.search(" ") == -1) &&
      (dominio.search(" ") == -1) &&
      (dominio.search(".") != -1) &&
      (dominio.indexOf(".") >= 1) &&
      (dominio.lastIndexOf(".") < dominio.length - 1)) {
      this.setState({ isEmail: true });
    } else {
      this.setState({ isEmail: false });
    }
  }

  confirmStatusApprove = async (e, list) => {
    let attach = list.filter(item => item.DocumentId == e.target.id);

    this.setState({
      msgError: null,
      msgAlert: null,
      idAttachment: attach[0].id,
      typeAttach: e.target.name
    });

    // Check if this is a Medição document and if it needs approver assignment
    if (e.target.name === 'medicao') {
      const currentUserId = localStorage.getItem("userId");
      const userTypeId = localStorage.getItem("UserTypeId");
      
      // Check if ANY Medição document for this company has an approver assigned
      const anyMedicaoWithApprover = this.state.companyDocumentsMedicao.find(doc => 
        doc.DocumentId == attach[0].DocumentId && 
        doc.ApproverUserId && 
        doc.ApproverUserId !== null
      );
      
      // Also check approver info from previous months
      const hasAssignedApprover = anyMedicaoWithApprover || this.state.medicaoApproverInfo;
      
      // Only admins (UserType 1) should see the approver assignment modal
      // For UserType 3 (approvers), they should only see the approval button if they are the assigned approver
      if (userTypeId == 1 && !hasAssignedApprover) {
        // Admin doing first-time approval - needs to assign approver
        if (!this.state.approvers.length) {
          await this.searchApprovers();
        }
        this.setState({
          approverAction: 'assign',
          medicaoDocumentId: attach[0].DocumentId,
          selectedApprover: null
        });
        document.getElementById("modal-approver-assignment").click();
        return;
      }
    }
    
    document.getElementById("modal-confirm").click();
  };

  confirmRepostFile = async (e, list, type) => {
    let attach = list.filter(item => item.DocumentId == e.target.id);
    this.setState({ repostType: type });
    this.setState({
      msgError: null,
      idAttachment: attach[0].id,
      typeAttach: e.target.name
    });
    document.getElementById("modal-repost").click();
  };

  confirmStatusReject = async (e, list) => {
    let attach = list.filter(item => item.DocumentId == e.target.id);
    this.setState({
      msgError: null,
      idAttachment: attach[0].id,
      typeAttach: e.target.name,
      msgAlert: null
    });
    document.getElementById("motivo").value = "";
    document.getElementById("modal-reject").click();
  };

  setStatusRejectDocument = async () => {
    this.setState({ load: true, msgError: null, msgAlert: null });

    let motivo = document.getElementById("motivo").value;

    await api
      .patch(
        `/companies/${this.state.companyId}/attachments/${this.state.idAttachment}`,
        {
          AttachmentStatusId: 4,
          note: motivo,
          UserId: localStorage.getItem("userId")
        }
      )
      .then(async result => {

        this.setState({
          load: false,
          msgError: null,
          msgAlert: result.data.msg,
          classText: "text-success"
        });

        setTimeout(() => {
          this.closeAllModals();
          this.setState({ msgAlert: null, classText: null });
        }, 2000);


        await this.searchDocumentsToCompany(this.state.CompanyTypeId);
        await this.searchDocumentsCompany(this.state.companyId);
        await this.searchDocumentsCompanyMedicao(this.state.companyId);
        await this.setStatusCompany();
      })
      .catch(err => {
        if (err) {
          this.setState({
            msgError: err.response.data.msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgError: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  verifyStatus = (id, list) => {
    if (list.length) {
      let status = list.filter(item => item.DocumentId == id);

      if (status[0]) {
        if (status[0].AttachmentStatus.id !== 1) {
          const UserName = status[0].User
            ? status[0].User.name
            : "Não informado";

          return `${status[0].AttachmentStatus.name} por : ${UserName}`;
        }
      } else {
        return "5";
      }
    }
  };

  verifyDocumentYear = (id, list) => {
    if (list.length) {
      const exist = list.filter(item => item.DocumentId == id);
      return exist.length > 0 ? exist[0].year : "";
    }
  };

  verifyDocumentMonth = (id, list) => {
    if (list.length) {
      const exist = list.filter(item => item.DocumentId == id);
      return exist.length > 0 ? exist[0].month : "";
    }
  };

  searchStatus = async () => {
    this.setState({ load: true });
    const response = await api.get(`/employee-status`);
    this.setState({ status: response.data.rows, employeesStatuses: response.data.rows, load: false });
  };

  filterContact = () => {
    let filterNome = document.getElementById("filterNome").value;
    let filterStatus = document.getElementById("filterStatus").value;
    this.searchDataEmployee(this.state.companyId, filterNome, filterStatus);
  };

  filterClear = () => {
    document.getElementById("filterNome").value = "";
    document.getElementById("filterStatus").value = "";
    this.searchDataEmployee(this.state.companyId, null, null);
  };

  viewDetailEmployee = e => {
    let detail = this.state.employees.filter(item => item.id == e.target.id);
    console.log(detail[0]);
    this.setState({ detailEmployee: detail[0] });
  };

  toggleDocs = e => {
    const currentState = this.state.showDocs;
    this.setState({ showDocs: !currentState });
  };

  toggleDocsPeriodic = e => {
    const currentState = this.state.showDocsPeriodic;
    this.setState({ showDocsPeriodic: !currentState });
  };

  toggleDocsMedicao = e => {
    const currentState = this.state.showDocsMedicao;
    this.setState({ showDocsMedicao: !currentState });
  };

  updateDateDocument = async e => {
    const validityDate = document.getElementById("data_integracao").value;

    this.setState({ msgError: "" });
    await api
      .patch(
        `/companies/${this.state.companyId}/attachmentsvalidity/${this.state.idAttachment}`,
        {
          validityDate: validityDate,
          AttachmentStatusId: this.state.idAttachmentValidateStatus
        }
      )
      .then(async result => {
        this.setState({ load: false, msgError: null });
        document.getElementById("closeModal").click();
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: result.data.msg,
          classText: "text-success"
        });
        await this.searchDocumentsToCompany(this.state.CompanyTypeId);
        await this.searchDocumentsCompany(this.state.companyId);
        await this.searchDocumentsCompanyMedicao(this.state.companyId);
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgError: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgError: "Erro no processamento. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  updateDateIntegration = async e => {
    const validityDate = document.getElementById("data_integracao_edit").value;
    console.log("data: " + validityDate);
    const integrationId = window.integrationId;
    if (!validityDate) {
      this.setState({ msgError: "Selecione uma data!" });
      return;
    } else {
      //Fechando modal prévio
      document.getElementById("close-modal-hist").click();
      await api
        .patch(`/integration-schedules/${integrationId}`, { showedUp: true, dt: validityDate })
        .then(async result => {
          this.setState({
            msgSuccess: result.data.msg,
            msgErro: null,
            load: false,
            updateDate: true
          });
          this.searchDataEmployee(this.state.companyId);

          setTimeout(() => {
            this.setState({ msgAlert: null, classText: null, updateDate: false });
            this.closeAllModals();
          }, 2500);
        });
    }
  };


  handleChangeDate = async e => {
    const { name, value } = e.target;

    this.setState({ [name]: value }, async () => {
      await this.searchDocumentsCompany(this.state.companyId);
      
      // Always refresh Medição documents if this company has Medição document types
      // This ensures proper clearing of data when switching to months with no records
      if (this.state.documentsToUploadMedicao && this.state.documentsToUploadMedicao.length > 0) {
        await this.searchDocumentsCompanyMedicao(this.state.companyId);
      }
    });
  };

  // Medição-related functions
  verifyFileApprovalMedicao = id => {
    const userId = localStorage.getItem("userId");
    const userTypeId = localStorage.getItem("UserTypeId");
    const { companyDocumentsMedicao, medicaoApproverInfo } = this.state;
    
    // Admins (UserType 1) can always approve
    if (userTypeId == 1) {
      return true;
    }
    
    // For UserType 3 (approvers), check if they are the assigned approver for this company's Medição documents
    if (userTypeId == 3) {
      // First check current month's documents
      if (Array.isArray(companyDocumentsMedicao)) {
        const assignedToThisUser = companyDocumentsMedicao.find(doc => 
          doc.ApproverUserId == userId
        );
        if (assignedToThisUser) return true;
      }
      
      // If no current month documents, check approver info from previous months
      if (medicaoApproverInfo && medicaoApproverInfo.ApproverUserId == userId) {
        return true;
      }
    }
    
    return false;
  };

  verifyDocumentApprover = (id, documents) => {
 
    if (!Array.isArray(documents)) {
      return "Não definido";
    }
    
    const document = documents.find(doc => doc.DocumentId == id);
    if (document && document.Approver) {
      return document.Approver.name;
    }
    return "Não definido";
  };

  toggleDocsMedicao = e => {
    const currentState = this.state.showDocsMedicao;
    this.setState({ showDocsMedicao: !currentState });
  };

  // Handle approver selection change
  handleApproverSelection = (e) => {
    this.setState({ selectedApprover: e.target.value });
  };

  // Assign approver to Medição documents
  assignApprover = async () => {
    const { selectedApprover, medicaoDocumentId, companyId } = this.state;
    
    if (!selectedApprover) {
      this.setState({
        msgAlert: 'Por favor, selecione um aprovador',
        classText: 'text-danger'
      });
      document.getElementById("modal-alert").click();
      return;
    }

    try {
      this.setState({ load: true });
      
      const response = await api.post(`/companies/${companyId}/assign-approver`, {
        documentId: medicaoDocumentId,
        approverId: selectedApprover
      });

      // Close approver modal and show success
      this.setState({
        msgAlert: response.data.msg,
        classText: 'text-success',
        load: false
      });
      
      // Close the modal manually
      this.closeAllModals();
      
      // Refresh the documents to show the assigned approver
      await this.searchDocumentsCompanyMedicao(companyId);
      
      // Continue with the approval process
      this.setStatusDocument();
      
      // Show success message
      document.getElementById("modal-alert").click();
      
    } catch (err) {
      this.setState({
        msgAlert: 'Erro ao designar aprovador',
        classText: 'text-danger',
        load: false
      });
      document.getElementById("modal-alert").click();
    }
  };

  // Reassign approver for existing Medição documents
  reassignApprover = async () => {
    const { selectedApprover, currentApprover, companyId } = this.state;
    
    if (!selectedApprover) {
      this.setState({
        msgAlert: 'Por favor, selecione um novo aprovador',
        classText: 'text-danger'
      });
      document.getElementById("modal-alert").click();
      return;
    }

    try {
      this.setState({ load: true });
      
      const response = await api.patch(`/companies/${companyId}/reassign-approver`, {
        documentId: 5, // Medição document type
        oldApproverId: currentApprover,
        newApproverId: selectedApprover,
        reason: 'Alteração solicitada pelo administrador'
      });

      // Close approver modal and show success
      this.setState({
        msgAlert: response.data.msg,
        classText: 'text-success',
        load: false
      });
      
      // Close the modal manually
      this.closeAllModals();
      
      // Refresh the documents to show the new approver
      await this.searchDocumentsCompanyMedicao(companyId);
      
      // Show success message
      document.getElementById("modal-alert").click();
      
    } catch (err) {
      this.setState({
        msgAlert: 'Erro ao alterar aprovador',
        classText: 'text-danger',
        load: false
      });
      document.getElementById("modal-alert").click();
    }
  };

  // Show change approver modal
  showChangeApproverModal = async (currentApproverId) => {
    // Load approvers if not already loaded
    if (!this.state.approvers.length) {
      await this.searchApprovers();
    }
    this.setState({
      approverAction: 'reassign',
      currentApprover: currentApproverId,
      selectedApprover: null
    });
    // Open the modal using the same pattern
    document.getElementById("modal-approver-assignment").click();
  };


  closeAllModals = () => {

    // get modals
    const modals = document.getElementsByClassName('modal');
    document.querySelector('body').classList.remove('modal-open');

    // on every modal change state like in hidden modal
    for (let i = 0; i < modals.length; i++) {
      modals[i].classList.remove('show');
      modals[i].setAttribute('aria-hidden', 'true');
      modals[i].setAttribute('style', 'display: none');
    }

    // get modal backdrops
    const modalsBackdrops = document.getElementsByClassName('modal-backdrop');

    // remove every modal backdrop
    for (let i = 0; i < modalsBackdrops.length; i++) {
      document.body.removeChild(modalsBackdrops[i]);
    }
  };

  fetchLostFiles = async () => {
    try {
      const response = await api.get(
        `/companies/${this.state.companyId}/lost-files`
      );
      this.setState({ lostFiles: response.data.rows, showLostFiles: true });
    } catch (error) {
      console.error("Error fetching lost files:", error);
    }
  };

  closeLostFiles = () => {
    this.setState({ showLostFiles: false, lostFiles: [] });
  };

  downloadLostFile = async (fileName) => {
    try {
      this.setState({ toastRender: true, timer: null });
      
      const encodedFileName = encodeURIComponent(fileName);
      const downloadLink = document.createElement("a");
      downloadLink.href = `${process.env.REACT_APP_BASE_URL}/companies/${this.state.companyId}/lost-files/${encodedFileName}/download`;
      downloadLink.download = fileName;
      downloadLink.click();
      
      this.setState({ toastRender: false, timer: 10 });
    } catch (error) {
      console.error("Error downloading lost file:", error);
      this.setState({ toastRenderError: true, toastRender: false });
    }
  };

  render() {
    const {
      companyDocuments,
      companyDocumentsPeriodic,
      companyStatusId,
      load,
      companyStatus,
      showDocs,
      documentsToUpload,
      documentsToUploadPeriodic,
      documentsToUploadMedicao,
      companyDocumentsMedicao,
      showDocsPeriodic,
      year,
      month,
      msgAlert,
      functions,
      sectors,
      status,
      msgError,
      sectorsSelected,
      classText,
      titleDocumentValidate,
      updateDate,
      isValidadeCalendar,
      companyId,
      socialName,
      cnpj,
      businessName,
      phone,
      CompanyType,
      CompanyTypeId,
      objectOfContract,
      address,
      number,
      complement,
      city,
      state,
      district,
      employees,
      detailEmployee,
      companyContacts,
      toastRender,
      toastRenderError,
      toastView,
      timer,
      lostFiles,
      showLostFiles
    } = this.state;
    return (
      <Fragment>
        {timer ? (
          <Toast timer={timer} />
        ) : null}
        {
          toastRender ? (
            <Toast message="Iniciando download, aguarde..." type="info" timer={timer} />
          ) : null
        }
        {
          toastRenderError ? (
            <Toast message="Erro ao consultar documento, contate o suporte técnico!" type="error" />
          ) : null
        }
        {
          toastView ? (
            <Toast message="Preparando para visualizar o arquivo, aguarde..." type="info" timer={timer} />
          ) : null
        }
        <a href="#" id="btn_download" target="_blank" download />
        <a href="#" id="btn_viewer" target="_blank" />
        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">
              Documentos da Empresa
              {load ? <i className="fa fa-spin fa-spinner" /> : null}
            </h3>
          </div>
        </div>

        <div className="row">
          <div className="p-b-10">
            <a
              href="../../solicitations"
              className="btn btn-rounded btn-outline-primary"
            >
              <i className="mdi mdi-arrow-left" />
            </a>
          </div>

          <div className="col-md-12 alert alert-primary">
            Status da Empresa: <strong>{companyStatus}</strong>
          </div>
        </div>

        {/* Inicio Dados da empresa */}
        <fieldset>
          <div className="row detail-company">
            <div className="col-md-8 p-10">
              <strong className="text-primary p-10">Razão Social:</strong>
              <span>{socialName}</span>
            </div>
            <div className="col-md-4 p-10">
              <strong className="text-primary p-10">CNPJ:</strong>
              <span>{cnpj}</span>
            </div>
            <div className="col-md-8 p-10">
              <strong className="text-primary p-10">Nome Fantasia:</strong>
              <span>{businessName}</span>
            </div>
            <div className="col-md-4 p-10">
              <strong className="text-primary p-10">Objeto de Contrato:</strong>
              <span>{objectOfContract}</span>
            </div>
            <div className="col-md-3 p-10">
              <strong className="text-primary p-10">Telefone:</strong>
              <span>{phone}</span>
            </div>
            <div className="col-md-5 p-10">
              <strong className="text-primary p-10">Tipo de Empresa:</strong>
              <span>{CompanyType}</span>
            </div>
            <div className="col-md-4 p-10">
              <strong className="text-primary p-10">UF:</strong>
              <span>{state}</span>
            </div>
            <div className="col-md-3 p-10">
              <strong className="text-primary p-10">Número:</strong>
              <span>{number}</span>
            </div>
            <div className="col-md-5 p-10">
              <strong className="text-primary p-10">Cidade:</strong>
              <span>{city}</span>
            </div>
            <div className="col-md-4 p-10">
              <strong className="text-primary p-10">Bairro:</strong>
              <span>{district}</span>
            </div>
            <div className="col-md-3 p-10">
              <strong className="text-primary p-10">Complemento:</strong>
              <span>{complement}</span>
            </div>
            <div className="col-md-6 p-10">
              <strong className="text-primary p-10">Endereço:</strong>
              <span>{address}</span>
            </div>
            <div className="col-md-3 p-10">
              <strong className="text-primary p-10">Área(s) Gestora(s):</strong>
              {sectorsSelected
                ? sectorsSelected.map((it, idx) => {
                  return idx == 0 ? (
                    <span className="label m-1 label-info" id={idx}>
                      {it.name}
                    </span>
                  ) : (
                    <span className="label m-1 label-info" id={idx}>
                      {it.name}
                    </span>
                  );
                })
                : "Indefinida"}
            </div>
          </div>
        </fieldset>
        {/* Fim Dados da empresa */}

        <br />

        {/* Inicio Dados dos contatos da empresa */}
        <fieldset>
          <legend>
            Contatos &nbsp;&nbsp;
            <button className="btn btn-rounded btn-outline-info " onClick={e => document.getElementById('modal-new-contact').click()}>
              Criar Novo
            </button>
          </legend>


          <div className="row detail-company">
            <div className="col-md-12 p-20">
              <ul className="feeds">
                {companyContacts.length
                  ? companyContacts.map(item => {
                    return (
                      <li key={item.id}>
                        <div className="bg-light-primary">
                          <i className="fa fa-user-o text-primary" />
                        </div>
                        <label>{item.name} </label> -
                        {item.UserStatusId == 2 ?
                          <i className="label label-light-danger">
                            Desativado
                          </i>
                          : null}
                        <i className="label label-light-primary"
                          id="1"
                          style={{ paddingTop: "10px", paddingBottom: "10px", marginLeft: "5px" }}>
                          {item.email}
                        </i>
                        <Link
                          to={`/contact-edit/${item.id}/${companyId}/`}
                          id={item.id}
                          title={item.name}
                          className="btn btn-rounded btn-outline-info"
                          style={{ marginLeft: "10px" }}
                        >
                          <i className="fa fa-edit" />
                        </Link>
                      </li>
                    );
                  })
                  : null}
              </ul>
            </div>
          </div>
        </fieldset>
        {/* Fim Dados dos contatos da empresa */}

        <br />

        {/* Inicio Documentos da empresa */}
        <fieldset>
          <legend>
            Documentos &nbsp;
            <button
              className="btn btn-sm btn-rounded btn-outline-success"
              title="Omitir lista de documentos"
              onClick={this.toggleDocs}
            >
              <i className={showDocs ? "fa fa-eye" : "fa fa-eye-slash"} />
            </button>
            &nbsp;
            <button
              className="btn btn-sm btn-rounded btn-outline-warning"
              title="Ver arquivos não catalogados"
              onClick={this.fetchLostFiles}
            >
              <i className="fa fa-exclamation-triangle" /> Arquivos Não Catalogados
            </button>
          </legend>
          {documentsToUpload.length
            ? documentsToUpload.map(item => (
              <div
                className={showDocs ? "row detail-company" : "hide"}
                key={item.id}
              >
                <div className="col-md-4 p-t-10" style={{ paddingBottom: "10px" }}>
                  <label>{item.description}</label>
                  {
                    (this.verifyStatus(item.id, companyDocuments) && this.verifyStatus(item.id, companyDocuments) !== "5") ?
                      (
                        <i
                          className="label label-light-success m-l-20"
                          id={item.id}
                        >
                          {this.verifyStatus(item.id, companyDocuments)}
                        </i>
                      ) : (
                        this.verifyStatus(item.id, companyDocuments) === "5" ?
                          (
                            <i
                              className="label label-light-warning m-l-20"
                              id={item.id}
                            >
                              {"Aguardando upload de documentos faltantes"}
                            </i>
                          ) : (
                            <i
                              className="label label-light-primary m-l-20"
                              id={item.id}
                            >
                              {"Aguardando aprovação"}
                            </i>
                          )
                      )
                  }

                  {this.verifyDocumentNote(item.id, companyDocuments) ? (
                    <i className="text-danger label label-light-danger m-l-20">
                      {this.verifyDocumentNote(item.id, companyDocuments)}
                    </i>
                  ) : null}

                  {this.verifyDocumentExpired(item.id, companyDocuments) ? (
                    <i className="text-danger label label-light-danger m-l-20">
                      {this.verifyDocumentExpired(item.id, companyDocuments)}
                    </i>
                  ) : null}
                </div>
                <div className="col-md-2 p-10">
                  {this.verifyFile(item.id, companyDocuments) &&
                    !this.verifyDocumentNotApplicable(
                      item.id,
                      companyDocuments
                    ) ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      id={item.id}
                      onClick={e => this.downloadFile(e, companyDocuments)}
                    >
                      <i className="fa fa-download" id={item.id} />
                    </button>
                  ) : null}

                  {this.verifyFile(item.id, companyDocuments) &&
                    !this.verifyDocumentNotApplicable(
                      item.id,
                      companyDocuments
                    ) ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      title="Visualizar Documento"
                      id={item.id}
                      onClick={e => this.viewFile(e, companyDocuments)}
                    >
                      <i className="fa fa-search" id={item.id} />
                    </button>
                  ) : null}

                  {this.verifyDocumentNotApplicable(
                    item.id,
                    companyDocuments
                  ) ? (
                    <i className="label label-light-warning" id={item.id}>
                      Documento não Aplicável
                    </i>
                  ) : null}
                </div>
                <div className="col-md-3 p-10">
                  {!this.verifyStatus(item.id, companyDocuments) &&
                    this.verifyFileApproval(item.id) &&
                    companyStatusId != 2 ? (
                    <button
                      className="btn btn-rounded btn-danger"
                      name="normal"
                      disabled={!this.verifyFile(item.id, companyDocuments)}
                      id={item.id}
                      onClick={e =>
                        this.confirmStatusReject(e, companyDocuments)
                      }
                    >
                      Rejeitar
                    </button>
                  ) : null}

                  {!this.verifyStatus(item.id, companyDocuments) &&
                    this.verifyFileApproval(item.id) &&
                    companyStatusId != 2 ? (
                    <button
                      className="btn btn-rounded btn-success"
                      name="normal"
                      disabled={!this.verifyFile(item.id, companyDocuments)}
                      id={item.id}
                      onClick={e =>
                        this.confirmStatusApprove(e, companyDocuments)
                      }
                    >
                      Aprovar
                    </button>
                  ) : null}


                  {/* BOTÃO DE REPOSTAR DOCUMENTO */}
                  {this.verifyFile(item.id, companyDocuments) && this.state.user_sector == '3' ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      style={{ marginTop: "10px" }}
                      id={item.id}
                      name="normal"
                      onClick={e => this.confirmRepostFile(e, companyDocuments, 'company')}
                    >
                      <i className="fa fa-repeat" id={item.id} />
                      &nbsp;&nbsp;Repostar
                    </button>
                  ) : null}


                </div>
                <div className="col-md-3 p-10">
                  {/* <b>Data de envio:</b> <Moment format="DD/MM/YYYY HH:mm">{item.createdAt}</Moment>  */}
                  <br />
                  <b>Data Validade:</b>{" "}
                  {this.showValidityDate(
                    item.DocumentToCompanyTypes,
                    companyDocuments
                  )}
                </div>
              </div>
            ))
            : null}
        </fieldset>
        {/* Fim Documentos da empresa */}

        <br />

        {/* Inicio Documentos Mensais da empresa */}
        <fieldset>
          <legend>
            Documentos Mensais &nbsp;
            <button
              className="btn btn-sm btn-rounded btn-outline-success"
              title="Omitir lista de documentos"
              onClick={this.toggleDocsPeriodic}
            >
              <i
                className={showDocsPeriodic ? "fa fa-eye" : "fa fa-eye-slash"}
              />
            </button>
          </legend>
          <DropMonthYear
            year={year}
            month={month}
            handleChangeDate={this.handleChangeDate}
          />

          {documentsToUploadPeriodic.length
            ? documentsToUploadPeriodic.map(item => (
              // if (this.verifyFileApprovalPeriodic(item.id)) {
              //   return (
              <div
                className={showDocsPeriodic ? "row detail-company" : "hide"}
                key={item.id}
              >
                <div className="col-md-4 p-t-10">
                  <label>{item.description}</label>
                  {this.verifyStatus(item.id, companyDocumentsPeriodic) ? (
                    <i
                      className="label label-light-primary m-l-20"
                      id={item.id}
                    >
                      {this.verifyStatus(item.id, companyDocumentsPeriodic)}
                    </i>
                  ) : null}

                  {this.verifyDocumentNote(
                    item.id,
                    companyDocumentsPeriodic
                  ) ? (
                    <i className="text-danger label label-light-danger m-l-20">
                      {this.verifyDocumentNote(
                        item.id,
                        companyDocumentsPeriodic
                      )}
                    </i>
                  ) : null}

                  {this.verifyDocumentExpired(
                    item.id,
                    companyDocumentsPeriodic
                  ) ? (
                    <i className="text-danger label label-light-danger m-l-20">
                      {this.verifyDocumentExpired(
                        item.id,
                        companyDocumentsPeriodic
                      )}
                    </i>
                  ) : null}
                </div>
                <div className="col-md-2 p-10">
                  {this.verifyFile(item.id, companyDocumentsPeriodic) &&
                    !this.verifyDocumentNotApplicable(
                      item.id,
                      companyDocumentsPeriodic
                    ) ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      title="Download"
                      id={item.id}
                      onClick={e =>
                        this.downloadFile(e, companyDocumentsPeriodic)
                      }
                    >
                      <i className="fa fa-download" id={item.id} />
                    </button>
                  ) : null}

                  {this.verifyFile(item.id, companyDocumentsPeriodic) &&
                    !this.verifyDocumentNotApplicable(
                      item.id,
                      companyDocumentsPeriodic
                    ) ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      title="Visualizar Documento"
                      id={item.id}
                      onClick={e =>
                        this.viewFile(e, companyDocumentsPeriodic)
                      }
                    >
                      <i className="fa fa-search" id={item.id} />
                    </button>
                  ) : // <AuthenticatedLink list={companyDocumentsPeriodic}>Download file now</AuthenticatedLink>
                    null}

                  {this.verifyDocumentNotApplicable(
                    item.id,
                    companyDocumentsPeriodic
                  ) ? (
                    <i className="label label-light-warning" id={item.id}>
                      Documento não Aplicável
                    </i>
                  ) : null}
                </div>
                <div className="col-md-3 p-10">
                  {!this.verifyStatus(item.id, companyDocumentsPeriodic) &&
                    this.verifyFileApprovalPeriodic(item.id) &&
                    companyStatusId != 2 ? (
                    <button
                      className="btn btn-rounded btn-danger"
                      disabled={
                        !this.verifyFile(item.id, companyDocumentsPeriodic)
                      }
                      id={item.id}
                      onClick={e =>
                        this.confirmStatusReject(e, companyDocumentsPeriodic)
                      }
                    >
                      Rejeitar
                    </button>
                  ) : null}
                  {!this.verifyStatus(item.id, companyDocumentsPeriodic) &&
                    this.verifyFileApprovalPeriodic(item.id) &&
                    companyStatusId != 2 ? (
                    <button
                      className="btn btn-rounded btn-success"
                      name="periodic"
                      disabled={
                        !this.verifyFile(item.id, companyDocumentsPeriodic)
                      }
                      id={item.id}
                      onClick={e =>
                        this.confirmStatusApprove(e, companyDocumentsPeriodic)
                      }
                    >
                      Aprovar
                    </button>
                  ) : null}


                  {/* BOTÃO DE REPOSTAR DOCUMENTO */}
                  {this.verifyFile(item.id, companyDocumentsPeriodic) && this.state.user_sector == '3' ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      id={item.id}
                      name="normal"
                      onClick={e => this.confirmRepostFile(e, companyDocumentsPeriodic, 'companyPeriodic')}
                    >
                      <i className="fa fa-repeat" id={item.id} />
                      &nbsp;&nbsp;Repostar
                    </button>
                  ) : null}


                </div>
                <div className="col-md-3 p-10">
                  {/* <b>Data de envio:</b> <Moment format="DD/MM/YYYY HH:mm">{item.createdAt}</Moment>  */}
                  <br /> {item.validityDate}
                  <b className="d-block">Competência:</b>
                  <p className="d-block">
                    {this.verifyDocumentMonth(
                      item.id,
                      companyDocumentsPeriodic
                    )}{" "}
                    -{" "}
                    {this.verifyDocumentYear(
                      item.id,
                      companyDocumentsPeriodic
                    )}
                  </p>
                  <b>Data Validade:</b>
                  {this.showValidityDate(
                    item.DocumentToCompanyTypes,
                    companyDocumentsPeriodic
                  )}
                </div>
              </div>
              //   );
              // }
            ))
            : null}
        </fieldset>
        {/* Fim Documentos Mensais da empresa */}

        {/* Inicio Documentos de Medição da empresa */}
        <fieldset>
          <legend>
            Documentos de Medição &nbsp;
            <button
              className="btn btn-sm btn-rounded btn-outline-success"
              title="Omitir lista de documentos"
              onClick={this.toggleDocsMedicao}
            >
              <i
                className={this.state.showDocsMedicao ? "fa fa-eye" : "fa fa-eye-slash"}
              />
            </button>
          </legend>
          {documentsToUploadMedicao.length
            ? documentsToUploadMedicao.map(item => (
              <div
                className={this.state.showDocsMedicao ? "row detail-company" : "hide"}
                key={item.id}
              >
                <div className="col-md-4 p-t-10">
                  <label>{item.description}</label>
                  {this.verifyStatus(item.id, companyDocumentsMedicao) ? (
                    <i
                      className="label label-light-primary m-l-20"
                      id={item.id}
                    >
                      {this.verifyStatus(item.id, companyDocumentsMedicao)}
                    </i>
                  ) : null}

                  {this.verifyDocumentNote(
                    item.id,
                    companyDocumentsMedicao
                  ) ? (
                    <i className="text-danger label label-light-danger m-l-20">
                      {this.verifyDocumentNote(
                        item.id,
                        companyDocumentsMedicao
                      )}
                    </i>
                  ) : null}

                  {this.verifyFile(item.id, companyDocumentsMedicao) &&
                    !this.verifyDocumentNotApplicable(
                      item.id,
                      companyDocumentsMedicao
                    ) ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success m-l-20"
                      id={item.id}
                      name="medicao"
                      onClick={e =>
                        this.viewFile(e, companyDocumentsMedicao)
                      }
                    >
                      <i className="fa fa-search" id={item.id} />
                    </button>
                  ) : null}

                  {this.verifyDocumentNotApplicable(
                    item.id,
                    companyDocumentsMedicao
                  ) ? (
                    <i className="label label-light-warning" id={item.id}>
                      Documento não Aplicável
                    </i>
                  ) : null}
                </div>
                <div className="col-md-3 p-10">
                  {!this.verifyStatus(item.id, companyDocumentsMedicao) &&
                    this.verifyFileApprovalMedicao(item.id) &&
                    companyStatusId != 2 ? (
                    <button
                      className="btn btn-rounded btn-danger"
                      disabled={
                        !this.verifyFile(item.id, companyDocumentsMedicao)
                      }
                      id={item.id}
                      onClick={e =>
                        this.confirmStatusReject(e, companyDocumentsMedicao)
                      }
                    >
                      Rejeitar
                    </button>
                  ) : null}
                  {!this.verifyStatus(item.id, companyDocumentsMedicao) &&
                    this.verifyFileApprovalMedicao(item.id) &&
                    companyStatusId != 2 ? (
                    <button
                      className="btn btn-rounded btn-success"
                      name="medicao"
                      disabled={
                        !this.verifyFile(item.id, companyDocumentsMedicao)
                      }
                      id={item.id}
                      onClick={e =>
                        this.confirmStatusApprove(e, companyDocumentsMedicao)
                      }
                    >
                      Aprovar
                    </button>
                  ) : null}

                  {/* BOTÃO DE REPOSTAR DOCUMENTO */}
                  {this.verifyFile(item.id, companyDocumentsMedicao) && this.state.user_sector == '3' && (() => {
                    const userId = localStorage.getItem("userId");
                    const document = companyDocumentsMedicao.find(doc => doc.DocumentId == item.id);
                    return document && document.ApproverUserId == userId;
                  })() ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      id={item.id}
                      name="medicao"
                      onClick={e => this.confirmRepostFile(e, companyDocumentsMedicao, 'companyMedicao')}
                    >
                      <i className="fa fa-repeat" id={item.id} />
                      &nbsp;&nbsp;Repostar
                    </button>
                  ) : null}
                </div>
                <div className="col-md-3 p-10">
                  <b className="d-block">Competência:</b>
                  <p className="d-block">
                    {this.verifyDocumentMonth(
                      item.id,
                      companyDocumentsMedicao
                    )}{" "}
                    -{" "}
                    {this.verifyDocumentYear(
                      item.id,
                      companyDocumentsMedicao
                    )}
                  </p>
                  <b className="d-block">Aprovador:</b>
                  <p className="d-block">
                    {this.verifyDocumentApprover(
                      item.id,
                      companyDocumentsMedicao
                    )}
                    {/* Show change approver button for UserType 1 (admins) */}
                    {localStorage.getItem("UserTypeId") == 1 && this.verifyDocumentApprover(item.id, companyDocumentsMedicao) !== "Não definido" ? (
                      <button
                        className="btn btn-sm btn-outline-warning m-l-10"
                        title="Alterar Aprovador"
                        onClick={() => {
                          const document = companyDocumentsMedicao.find(doc => doc.DocumentId == item.id);
                          this.showChangeApproverModal(document ? document.ApproverUserId : null);
                        }}
                      >
                        <i className="fa fa-user-plus" />
                      </button>
                    ) : null}
                  </p>
                </div>
              </div>
            ))
            : null}
        </fieldset>
        {/* Fim Documentos de Medição da empresa */}

        <br />

        {/* Inicio Funcionários da empresa */}
        <fieldset>
          <legend>Funcionários</legend>
          {employees.length > 0 &&
            functions.length > 0 &&
            sectors.length > 0 &&
            companyStatusId ? (
            <EmployeeTable
              loading={load}
              CompanyTypeId={CompanyTypeId}
              CompanyStatusId={companyStatusId}
              functions={this.functions}
              sectors={this.sectors}
              employees={employees}
              status={this.status}
            />
          ) : null}
        </fieldset>
        {/* Fim Funcionários da empresa */}

        <ModalConfirm
          title="Confirmação"
          msg="Tem certeza que deseja aprovar o documento?"
          function={this.setStatusDocument}
          msgError={msgError}
        />
        <ModalAlert
          title="Documento(s)"
          msg={msgAlert}
          function=""
          classText={classText}
        />

        <div
          id="modal-reject"
          data-toggle="modal"
          data-target=".modal-reject"
        />

        <div
          id="modal-new-contact"
          data-toggle="modal"
          data-target=".modal-new-contact"
        />

        <div
          id="modal-repost"
          data-toggle="modal"
          data-target=".modal-repost"
        />

        <div
          id="modal-approver-assignment"
          data-toggle="modal"
          data-target=".modal-approver-assignment"
        />

        <div
          id="modal-alter-status-employee"
          data-toggle="modal"
          data-target=".modal-alter-status-employee"
        />

        <div
          id="modal-validade-date"
          data-toggle="modal"
          data-target=".modal-validade-date"
        />

        <div
          id="modal-alter-date-integration"
          data-toggle="modal"
          data-target=".modal-alter-date-integration"
        />

        <div
          id="modal-employee-status"
          data-toggle="modal"
          data-target=".modal-employee-status"
        />

        {/* Inicio Modal Rejeitar documento */}
        <div
          className="modal fade modal-reject"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Rejeitar
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Tem certeza que deseja rejeitar o documento?
                        <br />
                        Coloque o motivo no campo abaixo.
                      </label>
                      <textarea id="motivo" className="form-control" rows="5" />
                    </div>
                  </div>

                  {msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-success">{msgAlert}</div>
                    </div>
                  ) : null}

                  {msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">{msgError}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.setStatusRejectDocument}
                >
                  Confirmar
                </button>
                <button
                  id="close-modal-reject"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal Rejeitar documento */}


        {/* Inicio Modal Repost documento */}
        <div
          className="modal fade modal-repost"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Repostar documento
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Tem certeza que deseja solictar a repostagem do documento?
                        <br />
                      </label>
                    </div>
                  </div>

                  {msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-success">{msgAlert}</div>
                    </div>
                  ) : null}

                  {msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">{msgError}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">

                <button
                  className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.setStatusRepostDocumentCompany}
                >
                  Confirmar
                </button>

                <button
                  id="close-modal-repost"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal Repost documento empresa */}


        {/* Inicio Modal novo contato */}
        <div
          className="modal fade modal-new-contact"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Adicionar novo contato
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Nome
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          id="nome_contato"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Email</label>
                        <input type="text"
                          className="form-control"
                          onBlur={this.isEmail}
                          id="email_contato" />
                        {(!this.state.isEmail) ? <i className="message-error">Email inválido</i> : null}
                      </div>
                    </div>
                  </div>

                  {msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-success">{msgAlert}</div>
                    </div>
                  ) : null}

                  {msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">{msgError}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">

                <button
                  className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.setNewContact}
                  disabled={!this.state.isEmail}
                >
                  Criar
                </button>

                <button
                  id="close-modal-new-contact"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal Novo contato empresa */}




        {/* Inicio Modal Altera status Employee Fixo */}
        <div
          className="modal fade modal-alter-status-employee"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Confirmação
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Tem certeza que deseja alterar o status do colaborador para 'Pendente de Aprovação'?
                        <br />
                      </label>
                    </div>
                  </div>

                  {msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-success">{msgAlert}</div>
                    </div>
                  ) : null}

                  {msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">{msgError}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.setStatusEmployee}
                >
                  Confirmar
                </button>
                <button
                  id="close-modal-alter-status-employee"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal Altera status Employee */}

        {/* Inicio Modal Altera status Employee DINAMICO */}
        <div
          className="modal fade modal-employee-status"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Confirmação
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">

                      <h5>Status do Funcionário</h5>
                      <select
                        id="employeeStatuses"
                        className="custom-select col-12"
                        value={window.employeeStatus}
                        onChange={e => window.employeeStatus = e.target.value}
                      >
                        <option>Selecione</option>
                        {this.state.employeesStatuses
                          ? this.state.employeesStatuses.map(item => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.description}
                              </option>
                            );
                          })
                          : null}
                      </select>

                    </div>
                  </div>

                  {msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-success">{msgAlert}</div>
                    </div>
                  ) : null}

                  {msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">{msgError}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.setStatusEmployeeNew}
                >
                  Confirmar
                </button>
                <button
                  id="close-modal-status-employee"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade modal-detail-employee"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Dados Funcionário
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="col-md-12 row">
                  <div className="col-md-12 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-2">Nome:</strong>
                      <div className="col-sm-10">{detailEmployee.name}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-6">Data Nascimento: </strong>
                      <div className="col-sm-6">
                        <Moment format="DD/MM/YYYY HH:mm">
                          {detailEmployee.birthDate}
                        </Moment>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-2">CPF:</strong>
                      <div className="col-sm-10">{detailEmployee.cpf}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-2">RG:</strong>
                      <div className="col-sm-10">{detailEmployee.rg}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-3">Celular:</strong>
                      <div className="col-sm-9">{detailEmployee.phone}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-3">Setor:</strong>
                      <div className="col-sm-9">{detailEmployee.sector}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-2">Email:</strong>
                      <div className="col-sm-10">{detailEmployee.email}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-2">País:</strong>
                      <div className="col-sm-10">{detailEmployee.country}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-4">UF:</strong>
                      <div className="col-sm-8">{detailEmployee.state}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-3">Cidade:</strong>
                      <div className="col-sm-9">{detailEmployee.city}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-3">Bairro:</strong>
                      <div className="col-sm-9">{detailEmployee.district}</div>
                    </div>
                  </div>

                  <div className="col-md-12 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-2">Endereço:</strong>
                      <div className="col-sm-10">{detailEmployee.address}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-4">Número:</strong>
                      <div className="col-sm-8">{detailEmployee.number}</div>
                    </div>
                  </div>

                  <div className="col-md-6 p-10 principal">
                    <div className="row">
                      <strong className="col-sm-4">Complemento:</strong>
                      <div className="col-sm-8">
                        {detailEmployee.complement}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  id="close-modal-reject"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Inicio Modal alterar data de validade do documento */}
        <div
          className="modal fade modal-validade-date"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  {titleDocumentValidate}
                  {load ? <i className="fa fa-spin fa-spinner" /> : null}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body row">
                <div className="col-md-12 p-3">
                  {updateDate ? (
                    <div className="alert alert-success">
                      Atualizado com sucesso!
                    </div>
                  ) : null}

                  <div className="col-md-12">
                    <span>
                      Nova validade <i className="text-danger">*</i>
                    </span>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        id="data_integracao"
                        onChange={this.ValidadeCalendar}
                      />
                      <span className="input-group-addon">
                        <i className="icon-calender" />
                      </span>
                    </div>
                  </div>
                </div>

                {msgError ? (
                  <div className="col-md-12 p-t-20 text-sm">
                    <div className="alert alert-danger">{msgError}</div>
                  </div>
                ) : null}

                <div className="col-md-12 text-sm">
                  <div className="alert alert-warning" style={{ fontSize: '12px' }}>Salve sem selecionar uma data para remover a Validade</div>
                </div>
              </div>
              <div className="modal-footer">
                {!updateDate ? (
                  <button
                    onClick={this.updateDateDocument}
                    disabled={!isValidadeCalendar}
                    className="col-md-6 btn waves-effect waves-light btn-rounded btn-success"
                  >
                    Salvar
                  </button>
                ) : null}
                <button
                  type="button"
                  id="closeModal"
                  className="col-md-6 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal alterar data de validade do documento */}

        {/* Inicio alterar data de integração do funcionário */}
        <div
          className="modal fade modal-alter-date-integration"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Atualizar data de integração
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body row">
                <div className="col-md-12 p-3">
                  {updateDate ? (
                    <div className="alert alert-success">
                      Atualizado com sucesso!
                    </div>
                  ) : null}

                  <div className="col-md-12">
                    <span>
                      Nova Data <i className="text-danger">*</i>
                    </span>
                    <div className="input-group">
                      <input
                        type="date"
                        className="form-control"
                        id="data_integracao_edit"
                      />
                      <input
                        type="hidden"
                        className="form-control"
                        id="data_integracao_edit_id"
                      />
                    </div>
                  </div>
                </div>

                {msgError ? (
                  <div className="col-md-12 p-t-20 text-sm">
                    <div className="alert alert-danger">{msgError}</div>
                  </div>
                ) : null}
              </div>
              <div className="modal-footer">
                {!updateDate ? (
                  <button
                    onClick={this.updateDateIntegration}
                    disabled={!isValidadeCalendar}
                    className="col-md-6 btn waves-effect waves-light btn-rounded btn-success"
                  >
                    Salvar
                  </button>
                ) : null}
                <button
                  type="button"
                  id="closeModal"
                  className="col-md-6 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal alterar data de integração do funcionário */}

        {showLostFiles && (
          <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      <i className="fa fa-exclamation-triangle text-warning" /> Arquivos Não Catalogados
                    </h5>
                    <button
                      type="button"
                      className="close"
                      onClick={this.closeLostFiles}
                    >
                      ×
                    </button>
                  </div>
                  <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    {lostFiles.length ? (
                      <>
                        <div className="alert alert-warning">
                          <strong>{lostFiles.length}</strong> arquivo(s) encontrado(s) no sistema de arquivos que não estão catalogados no banco de dados.
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Nome do Arquivo</th>
                                <th>Tamanho</th>
                                <th>Data de Criação</th>
                                <th>Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              {lostFiles.map((file, index) => (
                                <tr key={index}>
                                  <td>{file.fileName}</td>
                                  <td>{(file.size / 1024).toFixed(2)} KB</td>
                                  <td>
                                    <Moment format="DD/MM/YYYY HH:mm">{file.createdAt}</Moment>
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-sm btn-rounded btn-outline-primary"
                                      onClick={() => this.downloadLostFile(file.fileName)}
                                    >
                                      <i className="fa fa-download" /> Download
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    ) : (
                      <p className="text-center text-muted">Nenhum arquivo não catalogado encontrado.</p>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={this.closeLostFiles}
                    >
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* Inicio Modal Seleção de Aprovador para Medição */}
        <div
          className="modal fade modal-approver-assignment"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  {this.state.approverAction === 'assign' ? 
                    'Designar Aprovador para Medição' : 
                    'Alterar Aprovador de Medição'
                  }
                  {this.state.load ? <i className="fa fa-spin fa-spinner" /> : null}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        {this.state.approverAction === 'assign' ? 
                          'Selecione o aprovador que será responsável pelos documentos de Medição desta empresa:' :
                          'Selecione o novo aprovador:'
                        }
                      </label>
                      <select
                        className="form-control"
                        value={this.state.selectedApprover || ''}
                        onChange={this.handleApproverSelection}
                      >
                        <option value="">Selecione um aprovador...</option>
                        {this.state.approvers.map(approver => (
                          <option key={approver.id} value={approver.id}>
                            {approver.name} ({approver.email})
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    {this.state.approverAction === 'assign' && (
                      <div className="alert alert-info">
                        <strong>Primeira aprovação:</strong> Após designar o aprovador, este documento será aprovado 
                        e o aprovador receberá uma notificação sobre sua responsabilidade pelos próximos envios mensais.
                      </div>
                    )}
                    
                    {this.state.approverAction === 'reassign' && (
                      <div className="alert alert-warning">
                        <strong>Alteração de aprovador:</strong> O aprovador atual e o novo aprovador receberão 
                        notificações sobre esta mudança.
                      </div>
                    )}
                  </div>

                  {this.state.msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className={`alert ${this.state.classText === 'text-success' ? 'alert-success' : 'alert-danger'}`}>
                        {this.state.msgAlert}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="col-md-3 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.state.approverAction === 'assign' ? this.assignApprover : this.reassignApprover}
                  disabled={!this.state.selectedApprover || this.state.load}
                >
                  {this.state.approverAction === 'assign' ? 'Designar e Aprovar' : 'Alterar Aprovador'}
                </button>
                <button
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal Seleção de Aprovador para Medição */}

      </Fragment>
    );
  }
}

export default Detail;
